import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {SubscriptionClose} from '../models/subscription-i';


export const endBillingActionTypes = {
  END_BILLING: type('[End Billing] Start'),
  END_BILLING_COMPLEX: type('[End Billing] Complex'),
  END_BILLING_SUCCESS: type('[End Billing]  Success'),
  END_BILLING_FAIL: type('[End Billing]  Fail'),
};

export class EndBillingAction implements Action {
  readonly type = endBillingActionTypes.END_BILLING;
  constructor(public payload?: {companyUuid: string, contractUuid: string, data: SubscriptionClose[], comment: string } ) {}
}
export class EndBillingActionComplex implements Action {
  readonly type = endBillingActionTypes.END_BILLING_COMPLEX;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class EndBillingSuccessAction implements Action {
  readonly type = endBillingActionTypes.END_BILLING_SUCCESS;
  constructor(public payload?: boolean) {}
}

export class EndBillingFailAction implements Action {
  readonly type = endBillingActionTypes.END_BILLING_FAIL;
  constructor(public payload?: string) {}
}


